import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from 'seagull';
import { ExpirationDate } from '~/components/AgreementStudioPage/AgreementStudioModal/ExpirationDate/ExpirationDate';
const DEFAULT_DAYS_TO_EXPIRATION = 30;
const expirationForToggle = (draft, defaultExpirationDays, hasExpirationDate)=>hasExpirationDate ? {
        type: 'days',
        days: defaultExpirationDays || draft.expirationDaysAfterSending() || DEFAULT_DAYS_TO_EXPIRATION
    } : null;
export const renderExpirationDateModal = (param)=>{
    let { draft, setDraft, title, defaultExpirationDays } = param;
    return {
        title,
        testId: 'edit-expiration-date-modal',
        content: /*#__PURE__*/ _jsx(Grid, {
            rowGap: "small",
            children: /*#__PURE__*/ _jsx(ExpirationDate, {
                daysToExpiration: draft.expirationDaysAfterSending() || 0,
                hasExpirationDate: draft.expirationDaysAfterSending() !== null,
                setDaysToExpiration: (days)=>setDraft(draft.setExpirationDate({
                        type: 'days',
                        days
                    })),
                setHasExpirationDate: (hasExpirationDate)=>setDraft(draft.setExpirationDate(expirationForToggle(draft, defaultExpirationDays, hasExpirationDate)))
            })
        }),
        onSubmit: (defaultBehavior)=>{
            defaultBehavior();
        }
    };
};
